module.exports = __webpack_public_path__ + "img/Butts-Mehre-t-15128-s015-474x357.5e5babbc.jpg";